module.exports = __webpack_public_path__ + "static/media/google_13.2f97c105.svg";